import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'presetButton']
  static values = { liveUpdate: { type: Boolean, default: false } }

  fill(event) {
    const amount = parseFloat(event.currentTarget.dataset.amount)

    this.inputTarget.value = amount

    if (this.liveUpdateValue) {
      this.inputTarget.dispatchEvent(new Event('input'))
      this.#activatePresetButton(event.currentTarget)
    }
  }

  #activatePresetButton(activeButton) {
    this.presetButtonTargets
      .filter(button => button !== activeButton)
      .forEach(button => button.classList.remove('active'))
    activeButton.classList.add('active')
  }
}
